/**
 * Push Button Switch Upsell — Plate PDP Widget
 *
 * Shows on push button plate pages. Detects gang size from handle,
 * fetches the switch product, and takes over the main Add to Bag
 * button to offer a plate + switches bundle.
 *
 * Accordion layout mirrors push-button-plate-picker.js.
 */
(function () {
  'use strict';

  var SWITCH_HANDLE = 'the-push-button-switch';

  // -- State --
  var switchProduct = null;
  var gangSize = 1;
  var switchQty = 1;
  var currentFinish = '';
  var currentPlatePrice = 0;
  var productTitle = '';

  // -- Image URLs for popdown --
  var plateImageSrc = '';
  var switchImageSrc = '';

  // -- DOM refs --
  var toggleEl = null;
  var bodyEl = null;
  var wrapperEl = null;
  var mainBtnEl = null;
  var mainBtnTextEl = null;
  var mainBtnPriceEl = null;
  var qtyInput = null;

  // -- Bundle-mode state --
  var bundleActive = false;
  var itemizedEl = null;
  var bundleInfoEl = null;
  var savedBtnText = '';
  var savedBtnPrice = '';

  function init() {
    var sourceEl = document.getElementById('switchUpsellSource');
    if (!sourceEl) return;

    var productInner = document.querySelector('.product__inner[data-product-form-wrapper]');
    if (!productInner) return;

    // Read data from Liquid
    var handle = sourceEl.dataset.productHandle || '';
    productTitle = sourceEl.dataset.productTitle || 'Push Button Plate';
    currentFinish = sourceEl.dataset.currentVariantTitle || '';
    currentPlatePrice = parseInt(sourceEl.dataset.currentVariantPrice, 10) || 0;

    var accTitle = sourceEl.getAttribute('data-accordion-title') || 'Complete Your Push Button Set';
    plateImageSrc = sourceEl.getAttribute('data-plate-image') || '';
    switchImageSrc = sourceEl.getAttribute('data-switch-image') || '';
    var switchImage = switchImageSrc;

    // Detect gang size from plate handle
    if (handle.indexOf('four-gang') !== -1) gangSize = 4;
    else if (handle.indexOf('triple-gang') !== -1) gangSize = 3;
    else if (handle.indexOf('double-gang') !== -1) gangSize = 2;
    else gangSize = 1;

    switchQty = gangSize;

    var accSub = 'Your new plate needs a switch \u2014 add ' + (gangSize > 1 ? 'them' : 'one') + ' below';

    // Derive assembled image (plate with fixtures, white bg) from the plate image URL
    // -Ob.png or -Ob-W.jpg → -Ob-W.jpg (white bg plate only)
    var assembledImageSrc = deriveAssembledImage(plateImageSrc);

    wrapperEl = document.createElement('div');
    wrapperEl.className = 'switch-upsell-accordion product-accordion';
    wrapperEl.innerHTML =
      '<div class="accordion__wrapper">' +
        '<div class="switch-upsell-accordion__header">' +
          '<label class="switch-upsell-cb-label">' +
            '<input type="checkbox" class="switch-upsell-cb-input" id="switchUpsellCheckbox" checked>' +
            '<span class="switch-upsell-cb-visual"></span>' +
          '</label>' +
          '<span class="switch-upsell-toggle__thumb" id="switchUpsellPlateThumb"></span>' +
          '<span class="switch-upsell-header__sep">+</span>' +
          '<span class="switch-upsell-toggle__thumb" id="switchUpsellSwitchThumb"></span>' +
          '<span class="switch-upsell-header__sep">=</span>' +
          '<span class="switch-upsell-toggle__thumb switch-upsell-toggle__thumb--assembled" id="switchUpsellAssembledThumb"></span>' +
          '<span class="switch-upsell-toggle__text">' +
            '<span class="switch-upsell-toggle__label">' + accTitle + '</span>' +
            '<span class="switch-upsell-toggle__sub">' + accSub + '</span>' +
          '</span>' +
        '</div>' +
        '<div class="switch-upsell-accordion__body"></div>' +
      '</div>';

    toggleEl = wrapperEl.querySelector('#switchUpsellCheckbox');
    bodyEl = wrapperEl.querySelector('.switch-upsell-accordion__body');

    // Insert before quantity/button block
    var qtyBlock = productInner.querySelector('.product__block__quantity');
    var buttonsBlock = productInner.querySelector('.product__block__buttons');
    var insertBefore = qtyBlock || buttonsBlock;
    if (insertBefore) {
      insertBefore.before(wrapperEl);
    } else {
      productInner.appendChild(wrapperEl);
    }

    sourceEl.remove();

    // Populate header thumbnails immediately — plate first, then switch
    var plateThumbEl = document.getElementById('switchUpsellPlateThumb');
    if (plateThumbEl && plateImageSrc) {
      plateThumbEl.innerHTML = '<img src="' + plateImageSrc + '" alt="" loading="lazy">';
    }
    var switchThumbEl = document.getElementById('switchUpsellSwitchThumb');
    if (switchThumbEl && switchImageSrc) {
      switchThumbEl.innerHTML = '<img src="' + switchImageSrc + '" alt="" loading="lazy">';
    }
    var assembledThumbEl = document.getElementById('switchUpsellAssembledThumb');
    if (assembledThumbEl && assembledImageSrc && assembledImageSrc !== plateImageSrc) {
      assembledThumbEl.innerHTML = '<img src="' + assembledImageSrc + '" alt="" loading="lazy">';
    }

    // Open immediately — no animation on page load
    bodyEl.style.display = 'block';

    // Cache main button refs
    mainBtnEl = productInner.querySelector('[data-add-to-cart]');
    mainBtnTextEl = productInner.querySelector('[data-add-to-cart-text]');
    mainBtnPriceEl = productInner.querySelector('[data-button-price]');
    qtyInput = productInner.querySelector('[data-quantity-input]');

    // Checkbox toggle: checked = bundle open, unchecked = close accordion
    toggleEl.addEventListener('change', function () {
      if (toggleEl.checked) {
        slideDown(bodyEl);
        activateBundle();
      } else {
        slideUp(bodyEl);
        deactivateBundle();
      }
    });

    // Listen for main quantity input changes while bundle is active
    if (qtyInput) {
      qtyInput.addEventListener('input', onMainQtyChange);
      qtyInput.addEventListener('change', onMainQtyChange);
    }

    // Fetch switch product then auto-activate bundle (bundle-default behaviour)
    fetch('/products/' + SWITCH_HANDLE + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        switchProduct = p;
        wrapperEl.style.display = '';
        activateBundle();
      })
      .catch(function () {});

    // Listen for variant changes on the plate PDP
    // Theme dispatches 'theme:variant:change' on the product container, not document
    var productSection = wrapperEl.closest('[data-section-type]') || productInner.closest('[data-section-type]') || document;
    productSection.addEventListener('theme:variant:change', onVariantChange);
  }

  function onVariantChange(e) {
    if (e.detail && e.detail.variant) {
      var v = e.detail.variant;
      if (v.title) currentFinish = v.title;
      if (v.price) currentPlatePrice = v.price;

      // Update plate thumb to match selected variant (swap src, no innerHTML flash)
      if (v.featured_image && v.featured_image.src) {
        var newPlateSrc = v.featured_image.src.replace(/\?.*/, '') + '?width=80';
        plateImageSrc = newPlateSrc;
        updateThumbSrc('switchUpsellPlateThumb', newPlateSrc);

        // Update assembled thumb
        var newAssembledSrc = deriveAssembledImage(newPlateSrc);
        if (newAssembledSrc !== newPlateSrc) {
          updateThumbSrc('switchUpsellAssembledThumb', newAssembledSrc);
        }
      }

      // Update switch thumb to match selected finish
      if (switchProduct) {
        var switchVariant = getVariant(switchProduct, currentFinish);
        if (switchVariant && switchVariant.featured_image && switchVariant.featured_image.src) {
          var newSwitchSrc = switchVariant.featured_image.src.replace(/\?.*/, '') + '?width=80';
          switchImageSrc = newSwitchSrc;
          updateThumbSrc('switchUpsellSwitchThumb', newSwitchSrc);
        }
      }

      if (bundleActive) {
        // Re-assert bundle price after theme updates (small delay)
        setTimeout(function () {
          activateBundle();
        }, 50);
      }
    }
  }

  function onMainQtyChange() {
    if (!bundleActive || !switchProduct) return;
    // Delay so we run AFTER the theme's own price update
    setTimeout(function () {
      if (!bundleActive) return;
      var switchVariant = getVariant(switchProduct, currentFinish);
      if (!switchVariant) return;

      var mainQty = parseInt(qtyInput.value, 10) || 1;
      var switchTotal = switchVariant.price * switchQty;
      var bundleTotal = (currentPlatePrice + switchTotal) * mainQty;

      if (mainBtnTextEl) mainBtnTextEl.textContent = 'Add Bundle to Cart';
      if (mainBtnPriceEl) mainBtnPriceEl.textContent = formatMoney(bundleTotal);
      showItemized(switchVariant, mainQty);
    }, 50);
  }

  // -- Bundle activation --
  function activateBundle() {
    if (!switchProduct || !mainBtnEl || !mainBtnTextEl || !mainBtnPriceEl) return;

    var switchVariant = getVariant(switchProduct, currentFinish);
    if (!switchVariant) return;

    // Save original button state (only on first activation)
    if (!bundleActive) {
      savedBtnText = mainBtnTextEl.textContent.trim();
      savedBtnPrice = mainBtnPriceEl.textContent.trim();
    }

    bundleActive = true;

    // Compute bundle total (respect main qty)
    var mainQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var switchTotal = switchVariant.price * switchQty;
    var bundleTotal = (currentPlatePrice + switchTotal) * mainQty;

    // Update main button
    mainBtnTextEl.textContent = 'Add Bundle to Cart';
    mainBtnPriceEl.textContent = formatMoney(bundleTotal);

    // Attach click interceptor
    mainBtnEl.removeEventListener('click', interceptClick, true);
    mainBtnEl.addEventListener('click', interceptClick, true);

    // Render itemized summary inside accordion body
    showItemized(switchVariant, mainQty);

    // Show remove link below button
    showBundleInfo();
  }

  function deactivateBundle() {
    if (!bundleActive) return;
    bundleActive = false;

    switchQty = gangSize;

    if (mainBtnTextEl) mainBtnTextEl.textContent = savedBtnText;
    if (mainBtnPriceEl) mainBtnPriceEl.textContent = savedBtnPrice;

    if (mainBtnEl) mainBtnEl.removeEventListener('click', interceptClick, true);

    hideItemized();
    hideBundleInfo();
  }

  function interceptClick(e) {
    if (!bundleActive) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addBundleToCart();
  }

  function addBundleToCart() {
    if (!switchProduct) return;

    var switchVariant = getVariant(switchProduct, currentFinish);
    if (!switchVariant) return;

    var formInput = document.querySelector('form[data-product-form] input[name="id"]');
    var plateVariantId = formInput ? parseInt(formInput.value, 10) : null;
    if (!plateVariantId) return;

    var mainQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    mainBtnEl.classList.add('loading');
    mainBtnEl.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: plateVariantId, quantity: mainQty },
          { id: switchVariant.id, quantity: switchQty * mainQty }
        ]
      })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart error');
      return r.json();
    })
    .then(function () {
      mainBtnEl.classList.remove('loading');
      mainBtnEl.classList.add('has-success');

      // Update header cart count
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          }));
          // Show custom bundle popdown instead of theme's single-variant popdown
          showBundlePopdown(switchVariant, mainQty);
        });

      setTimeout(function () {
        mainBtnEl.classList.remove('has-success');
        mainBtnEl.disabled = false;
      }, 3000);
    })
    .catch(function () {
      mainBtnEl.classList.remove('loading');
      mainBtnEl.disabled = false;
      mainBtnTextEl.textContent = 'Error \u2014 try again';
      setTimeout(function () {
        if (bundleActive) mainBtnTextEl.textContent = 'Add Bundle to Cart';
      }, 2500);
    });
  }

  // -- Custom bundle popdown (replaces theme's single-variant popdown) --
  function showBundlePopdown(switchVariant, mainQty) {
    var popdownEl = document.querySelector('[data-product-add-popdown-wrapper]');
    if (!popdownEl) return;

    var switchLabel = (switchQty * mainQty) === 1
      ? '1 Push Button Switch'
      : (switchQty * mainQty) + ' Push Button Switches';
    var plateLabel = mainQty === 1
      ? '1 \u00D7 ' + productTitle
      : mainQty + ' \u00D7 ' + productTitle;

    var imagesHtml = (plateImageSrc ? '<img src="' + plateImageSrc + '" alt="">' : '') +
                     (plateImageSrc && switchImageSrc ? '<span class="plate-picker-popdown__plus">+</span>' : '') +
                     (switchImageSrc ? '<img src="' + switchImageSrc + '" alt="">' : '');

    popdownEl.innerHTML =
      '<div class="product__popdown__outer" role="alertdialog" aria-labelledby="dialogTitle">' +
        '<div class="product__popdown__textbar">' +
          '<span class="product__popdown__title product__popdown__title--bold">' +
            'Bundle added &mdash; ' +
          '</span>' +
          '<span class="product__popdown__title">' +
            plateLabel + ' + ' + switchLabel +
          '</span>' +
        '</div>' +
        '<div class="wrapper !my-auto">' +
          '<div class="product__popdown__inner">' +
            '<div class="product__popdown__close">' +
              '<button class="popdown__close__inner" aria-label="Close" data-close-popdown>' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="2" y1="2" x2="14" y2="14"/><line x1="14" y1="2" x2="2" y2="14"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="product__popdown__image plate-picker-popdown__images">' + imagesHtml + '</div>' +
            '<div class="product__popdown__cart__wrapper">' +
              '<a href="/cart" class="product__popdown__cart btn-text-thick-line" data-drawer-toggle="drawer-cart">View cart</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    popdownEl.classList.add('is-visible');

    // Close button
    var closeBtn = popdownEl.querySelector('[data-close-popdown]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popdownEl.classList.remove('is-visible');
      });
    }

    // Auto-close after 5 seconds
    setTimeout(function () {
      popdownEl.classList.remove('is-visible');
    }, 5000);
  }

  // -- Itemized summary (inside accordion body) --
  function showItemized(switchVariant, mainQty) {
    if (!bodyEl) return;
    if (!mainQty) mainQty = 1;

    var switchTotal = switchVariant.price * switchQty;
    var bundleUnit = currentPlatePrice + switchTotal;
    var bundleTotal = bundleUnit * mainQty;

    var switchLabel = switchQty === 1
      ? '+ Push Button Switch'
      : '+ Push Button Switch \u00D7 ' + switchQty;

    var html =
      '<div class="switch-upsell-itemized">' +
        '<div class="switch-upsell-itemized__row">' +
          '<span>' + productTitle + '</span>' +
          '<span>' + formatMoney(currentPlatePrice) + '</span>' +
        '</div>' +
        '<div class="switch-upsell-itemized__row switch-upsell-itemized__row--addon">' +
          '<span>' + switchLabel + '</span>' +
          '<span class="switch-upsell-itemized__addon-right">' +
            '<span class="switch-upsell-qty">' +
              '<button type="button" class="switch-upsell-qty__btn" data-switch-qty-minus' +
                (switchQty <= 1 ? ' disabled' : '') + '>&minus;</button>' +
              '<span class="switch-upsell-qty__val">' + switchQty + '</span>' +
              '<button type="button" class="switch-upsell-qty__btn" data-switch-qty-plus>+</button>' +
            '</span>' +
            '<span>' + formatMoney(switchTotal) + '</span>' +
          '</span>' +
        '</div>' +
        '<div class="switch-upsell-itemized__row switch-upsell-itemized__row--total">' +
          '<span>Bundle Total' + (mainQty > 1 ? ' (\u00D7 ' + mainQty + ')' : '') + '</span>' +
          '<span>' + formatMoney(bundleTotal) + '</span>' +
        '</div>' +
      '</div>';

    bodyEl.innerHTML = html;
    itemizedEl = bodyEl.querySelector('.switch-upsell-itemized');

    // Bind qty buttons
    var minusBtn = bodyEl.querySelector('[data-switch-qty-minus]');
    var plusBtn = bodyEl.querySelector('[data-switch-qty-plus]');
    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        if (switchQty > 1) {
          switchQty--;
          activateBundle();
        }
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        switchQty++;
        activateBundle();
      });
    }
  }

  function hideItemized() {
    if (bodyEl) bodyEl.innerHTML = '';
    itemizedEl = null;
  }

  // -- Bundle info (below button) --
  function showBundleInfo() {
    var buttonsWrapper = mainBtnEl ? mainBtnEl.closest('.product__submit__buttons') : null;
    if (!buttonsWrapper) return;

    if (!bundleInfoEl) {
      bundleInfoEl = document.createElement('div');
      bundleInfoEl.className = 'switch-upsell-bundle-info';
      buttonsWrapper.after(bundleInfoEl);
    }

    bundleInfoEl.style.display = 'none';
  }

  function hideBundleInfo() {
    if (bundleInfoEl) bundleInfoEl.style.display = 'none';
  }

  // -- Slide helpers (same as plate picker) --
  function slideDown(el) {
    el.style.display = 'block';
    el.style.overflow = 'hidden';
    var h = el.scrollHeight;
    el.style.height = '0px';
    el.offsetHeight; // force reflow
    el.style.transition = 'height 0.3s ease';
    el.style.height = h + 'px';
    setTimeout(function () {
      el.style.height = 'auto';
      el.style.overflow = '';
      el.style.transition = '';
    }, 310);
  }

  function slideUp(el) {
    el.style.overflow = 'hidden';
    el.style.height = el.scrollHeight + 'px';
    el.offsetHeight; // force reflow
    el.style.transition = 'height 0.3s ease';
    el.style.height = '0px';
    setTimeout(function () {
      el.style.display = 'none';
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
    }, 310);
  }

  // -- Helpers --
  function updateThumbSrc(id, src) {
    var el = document.getElementById(id);
    if (!el) return;
    var img = el.querySelector('img');
    if (img) {
      img.src = src;
    } else {
      el.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
    }
  }

  function deriveAssembledImage(src) {
    // -Ob.png or -Ob-W.jpg → -Oh-W.jpg (plate with switches, white bg)
    return src.replace(/-Ob(-W)?(_\d+x)?\.(png|jpg)/, '-Oh-W$2.jpg');
  }

  function getVariant(product, finishTitle) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].title === finishTitle) return product.variants[i];
    }
    return product.variants[0];
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
